var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3850_407436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8719 28.8891C39.4277 28.8891 38.9873 28.8891 38.5431 28.8891V27.5144H35.7897V26.1396H34.415C34.415 25.6724 34.415 25.2167 34.415 24.7648H35.7897V23.3901H37.1645V22.0153H38.5622V8.25622H37.1645V6.88146H34.4111V5.5067H31.6616V4.13194H28.9083V2.75718H16.5278V1.38242H13.7782V0H8.27537V1.37476H5.52202V2.74952H1.39774V24.761H0V33.0172H1.39774V34.392H4.14726V35.7668H6.90061V37.1415H9.65013V38.5163H12.4035V39.891H15.153V41.2658H17.9064V42.6406H20.6597V43.9962H26.1626V42.6406H27.5527C27.7403 42.6406 27.9165 42.6406 28.0926 42.6406H28.4258C28.5292 42.6406 28.6517 42.6406 28.7551 42.6406H28.9159V41.2658H31.6654V39.891H34.415V38.5163H37.1683V37.1415H39.9408V28.8853H39.8719V28.8891Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90463 2.75336H8.27939V1.3786H13.7823V2.75336H16.5356V4.12429H19.2775V5.50671H22.0385V6.88147H24.7918V8.25623H27.5452V9.63099H28.9199V11.0172H27.5337V12.3805H23.4171V11.0058H20.6637V9.63099H17.9104V8.25623H15.157V6.88147H12.4037V5.50671H9.65032V4.13195H6.89697V2.75719L6.90463 2.75336Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77637 26.1396V24.7648H4.15113V26.1396H2.77637Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.04 9.63099H34.4148V8.25623H37.1681V22.0153H35.7934V23.3901H34.4646C34.4646 23.3901 34.4416 23.4092 34.4339 23.4207C34.4263 23.4322 34.4186 23.4475 34.4186 23.459C34.4186 24.3436 34.4186 25.2244 34.4186 26.1396H33.0439V9.63099H33.04Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1684 28.8891V30.2601H34.4265V31.6425H30.2907V33.0172H28.916V34.392H26.1626V35.7668H23.4131V41.2696H26.1626V39.8949H28.916V38.5201H31.6655V37.1454H34.4188V35.7706H37.1722V34.3958H38.5469V28.893H37.1722L37.1684 28.8891Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7876 12.3805H27.5295V11.0172H28.9157V9.63098H30.2905V30.2677C30.0377 30.2677 29.808 30.2677 29.582 30.2677C29.3599 30.2715 29.134 30.2486 28.9157 30.283V31.6425H26.1624V33.0172H24.7876V12.3805Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15088 26.1396H5.52564V27.5143H4.15088V26.1396Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2793 9.63098H11.0326V11.0057H13.786V12.3805H16.5393V13.7553H19.2927V15.1147C19.511 15.153 19.7369 15.1262 19.959 15.13C20.185 15.1339 20.4109 15.13 20.6675 15.13V26.1358H19.2927V24.761H16.5393V23.3862H13.786V22.0115H11.0326V20.6367H8.2793V9.63098Z",
    fill: "#E81717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9043 27.5143V28.8891H9.65765V27.5143H6.9043Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65381 28.8891V30.2639H12.4072V28.8891H9.65381Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 30.2677V31.6425H15.1567V30.2677H12.4072Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1567 31.6425V33.0172H17.9101V31.6425H15.1567Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9102 34.392H20.6597V33.0172H17.9102V34.392Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6597 34.392V35.7668C21.349 35.7668 20.6597 35.7668 21.349 35.7668H23.413V34.392H20.6635H20.6597Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15088 26.1396V27.5143H6.9004V26.1396H4.15088Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40137 24.7648V26.1396H4.15472V24.7648H1.40137Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 26.1396V27.5143H20.6599V26.1396H19.2852Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2793 20.6367V22.0115H11.0326V20.6367H8.2793Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0288 22.0115V23.3862H13.7783V22.0115H11.0288Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 23.3863V24.761H16.5356V23.3863H13.7822Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 24.7648V26.1396H19.2813V24.7648H16.5317Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27909 8.25623H6.88135V20.6367H8.27909V8.25623Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6595 11.0057H17.91V9.63097H15.1566V8.25621H12.4071V6.88145H9.65375V5.50669H6.9004V4.13193H4.15088V24.7687H6.9004V26.1434H9.65375V27.5182H12.4071V28.8929H15.1566V30.2677H17.91V31.6425H20.6595V33.0172H23.4128V12.3805H20.6595V11.0057ZM21.9845 13.7591C21.9845 13.7591 22.0075 13.7782 22.0189 13.7897C22.0266 13.8012 22.0343 13.8165 22.0343 13.828C22.0343 18.8331 22.0343 23.8381 22.0343 28.8508C22.0266 28.8585 22.0151 28.87 22.0036 28.8776C21.9921 28.8853 21.9768 28.8929 21.9653 28.8929C21.0807 28.8929 20.2 28.8929 19.2847 28.8929V27.5182H16.5352V26.1434H13.7819V24.7687H11.0323V23.3939H8.27899V22.0191H5.57925C5.57925 22.0191 5.55627 22 5.54479 21.9885C5.53713 21.977 5.52947 21.9617 5.52947 21.9502C5.52947 16.9452 5.52947 11.9401 5.52947 6.9274C5.53713 6.91974 5.54862 6.90825 5.5601 6.9006C5.57159 6.89294 5.58691 6.88528 5.5984 6.88528C6.48299 6.88528 7.36376 6.88528 8.27899 6.88528V8.26004H11.0323V9.6348H13.7819V11.0096H16.5352V12.3843H19.2847V13.7591H21.9845Z",
    fill: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2851 34.392H16.5355V33.0172H13.7822V31.6425H11.0327V30.2677H8.27932V28.893H5.52979V27.5182H4.15503V26.1434H2.78027V33.0211H4.15503V34.3958H6.90456V35.7706H9.65791V37.1453H12.4113V38.5201H15.1608V39.8949H17.9141V41.2696H20.6636V42.6444H22.0384V35.7668H19.2851V34.3882V34.392Z",
    fill: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6657 6.87763V5.50287H28.9123V4.12811H22.0347V5.50287H24.788V6.87763H27.5375V8.25239H30.2909V9.62716H34.419V6.87381H31.6695L31.6657 6.87763Z",
    fill: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1626 41.2734H28.9159V39.8987H26.1626V41.2734Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4131 42.6482H26.1626V41.2734H23.4131V42.6482Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 37.1453H37.1723V35.7706H34.4189V37.1453Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1685 34.392V35.7668H38.5432V34.392H37.1685Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0403 26.1396V9.63098H31.6655V27.5144H33.0403V26.1396Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.916 39.8949H31.6655V38.5201H28.916V39.8949Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6655 38.5201H34.4189V37.1454H31.6655V38.5201Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9159 33.0172H26.1626V34.392H28.9159V33.0172Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1626 34.392H23.4131V35.7668H26.1626V34.392Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8832 28.8891H32.55C32.4926 28.8891 32.4313 28.8891 32.3739 28.8891C32.3241 28.8891 32.2705 28.8891 32.2169 28.8891H31.6616V31.6425H34.4226V30.26H37.1645V28.8891H35.7897V27.5143H33.0364V28.8738C32.9828 28.8814 32.9292 28.8891 32.8755 28.8929L32.8832 28.8891Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2908 33.0172H31.6655V31.6501H30.2908V31.6425H28.916V33.0172H30.2908Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 0H8.2793V1.37476H13.7822V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2775 4.12046V5.50288H22.0385V4.1779C22.0385 4.1779 22.0577 4.15492 22.0692 4.14344C22.0806 4.13578 22.096 4.12812 22.1074 4.12812C24.3783 4.12812 26.6491 4.12812 28.9162 4.12812V2.75336H16.5356V4.12429H19.2775V4.12046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 6.87763V5.50287H31.6655V6.87763H34.4189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6655 5.50287V4.12811H28.916V5.50287H31.6655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9102 41.2734V42.6482H20.6597V41.2734H17.9102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.916 41.2734H31.6655V39.8987H28.916V41.2734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1567 39.8949V41.2696H17.9101V39.8949H15.1567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6655 39.8949H34.4189V38.5201H31.6655V39.8949Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 2.75336V1.3786H13.7783V2.75336H16.5317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1682 28.8891H38.543V27.5143H35.7935V28.8891H37.1682Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 38.5201V39.8949H15.1567V38.5201H12.4072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27931 2.75336V1.3786H5.52979V2.75336H8.27931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1684 8.25623V6.88147H34.415V8.25623H37.1684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 38.5201H37.1723V37.1454H34.4189V38.5201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65381 37.1454V38.5201H12.4072V37.1454H9.65381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77633 33.0172H1.40157V24.761H4.15109V23.3862H2.82228C2.74952 22.9688 2.72272 5.8858 2.79164 4.12427H5.52968V2.74951H1.40157V24.761H0V33.0172H1.39774V34.392H4.15109V33.0172H2.77633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15088 34.392V35.7668H6.9004V34.392H4.15088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9043 35.7706V37.1453H9.65765V35.7706H6.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7935 23.3862H37.1682V22.0115H35.7935V23.3862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0347 5.50287V6.87763H24.788V5.50287H22.0347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7876 6.87762V8.25239H27.5371V6.87762H24.7876Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5371 8.25623V9.63099H30.2905V8.25623H27.5371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.413 33.0172H20.6597V34.392H26.1625V33.0172H23.413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 12.3805V11.0057H13.7783V12.3805H16.5317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 13.7591V12.3843H16.5356V13.7591H19.2852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0287 23.3862V22.0115H8.27539V23.3862H11.0287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 26.1396V24.7648H13.7783V26.1396H16.5317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 24.7648V23.3901H11.0327V24.7648H13.7822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 11.0057V9.63098H11.0327V11.0057H13.7822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15088 24.7648V26.1396H6.9004V24.7648H4.15088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0287 9.63099V8.25623H8.27539V9.63099H11.0287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9043 26.1396V27.5143H9.65765V26.1396H6.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 27.5143V26.1396H16.5356V27.5143H19.2852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65381 27.5143V28.8891H12.4072V27.5143H9.65381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 28.8891V30.2639H15.1567V28.8891H12.4072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1567 30.2677V31.6425H17.9101V30.2677H15.1567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9102 31.6425V33.0172H20.6597V31.6425H17.9102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5279 22.0115H38.5662V8.25623H37.1685V22.0153H38.5279V22.0115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 28.8891C39.4278 28.8891 38.9874 28.8891 38.5432 28.8891V35.7667H37.1685V37.1415H39.941V28.8853H39.872V28.8891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52588 8.25622V22.0153H8.2754V20.6406H6.94659C6.92745 20.5295 6.91213 19.6909 6.90064 18.4999V8.88807C6.90447 8.62384 6.9083 8.40556 6.91596 8.26005H8.2754V6.88528H5.52588V8.26005V8.25622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0347 27.5144C22.0347 23.3862 22.0347 19.2581 22.0347 15.1339V13.7591H19.2852V15.1339H19.446C19.557 15.1415 19.6643 15.1339 19.7753 15.1339H20.1123C20.2885 15.1339 20.4646 15.1339 20.6599 15.1339V27.5144H19.2852V28.8891H22.0347V27.5144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 23.3863V24.761H35.7937V23.3863H34.4189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0402 26.1396H31.6655V9.63098H30.2907V30.2677C30.0954 30.2677 29.9154 30.2677 29.7393 30.2677H29.4061C29.2951 30.2677 29.184 30.26 29.0768 30.2677H28.9159V31.6425H26.1626V33.0172H28.9159V31.6501H31.6693V28.8891C31.8684 28.8891 32.0484 28.8891 32.2246 28.8891H33.0479V27.5144H35.8012V26.1396H34.4265V24.7648H33.0517V26.1396H33.0402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.413 42.6482H20.6597V44.0038H26.1625V42.6482H23.413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1626 42.6482H27.5527C27.7403 42.6482 27.9165 42.6482 28.0926 42.6482H28.4258C28.5292 42.6482 28.6517 42.6482 28.7551 42.6482H28.9159V41.2734H26.1626V42.6482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82242 23.3863H4.15123V4.12811H2.79178C2.72285 5.88964 2.75349 22.9727 2.82242 23.3901V23.3863Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52588 2.75336V4.12812H6.90064V2.75336H5.52588Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4131 12.3805V33.0172H24.7878V12.3805H23.4131Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9102 9.63098V11.0057H20.6597V9.63098H17.9102Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65381 5.50287V6.87763H12.4072V5.50287H9.65381Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6597 11.0057V12.3805H23.413V11.0057H20.6597Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9043 4.12811V5.50287H9.65765V4.12811H6.9043Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 6.87762V8.25239H15.1567V6.87762H12.4072Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1567 8.25623V9.63099H17.9101V8.25623H15.1567Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 34.392H17.9065V33.0172H16.5317V34.392Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 33.0172H15.157V31.6425H13.7822V33.0172Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0288 31.6425H12.4036V30.2677H11.0288V31.6425Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2793 30.2677H9.65406V28.8929H8.2793V30.2677Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40137 33.0172H2.77613V26.3387C2.77613 26.3387 2.77613 26.3081 2.77613 26.1358H1.40137V33.0134V33.0172Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52588 28.8891H6.90064V27.5143H5.52588V28.8891Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 35.7706H20.6599V34.3958H19.2852V35.7706Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0347 42.6482H23.4094V35.7706H22.0347V42.6482Z",
    fill: "#DDE3E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3850_407436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9446,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo_only.03cb64cb9b8ff95a6802b64e5050edad.svg";
export { ForwardRef as ReactComponent };